import { observable, action } from "mobx";
import PhotoEditingJobRepository from "~/repository/PhotoEditing/PhotoEditingJobRepository";
import ProviderBetaFeaturesRepository from "~/repository/ProviderBetaFeaturesRepository";
import PhotoEditingJob from "~/models/PhotoEditing/PhotoEditingJob";

class CreateJobStore {
  /**
   * @property {boolean}
   */
  @observable isLoading = false;

  @observable tourId = null;

  @observable isHDRealEnabled = false;

  @observable photoEditingJobs = [];

  photoEditingJobRepository = null;

  providerBetaFeaturesRepository = null;

  constructor(tourId = null) {
    this.tourId = tourId;
    this.photoEditingJobRepository = new PhotoEditingJobRepository();
    this.providerBetaFeaturesRepository = new ProviderBetaFeaturesRepository();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([
      this.providerBetaFeaturesRepository.fetch().then(response => {
        this.isHDRealEnabled = response.data.providerBetaFeatures.HDRealEnabled.value;
      }),
      this.photoEditingJobRepository.fetch({ tourId: this.tourId }).then(response => {
        this.receivePhotoEditingJobs(response.data.photoEditingJobs);
      }),
    ]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  receivePhotoEditingJobs(photoEditingJobs) {
    this.photoEditingJobs.clear();

    photoEditingJobs.forEach(photoEditingJob => {
      this.photoEditingJobs.push(new PhotoEditingJob(photoEditingJob));
    });
  }

  @action
  createPhotoEditingJob(typeId) {
    this.isLoading = true;

    return this.photoEditingJobRepository.create(this.tourId, typeId).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Find the first basic hdr job, as long as it is in creation status.
   * @return {PhotoEditingJob|null}
   */
  findFreeBasicHDRJobInCreation() {
    // If the job type is basic hdr, make sure we don't allow the user to create a new one if they already
    // got one in creation. If so, we'll redirect them to that job. See NEST-496.
    const existingBasicHDRJobs = this.photoEditingJobs.filter(photoEditingJob => {
      return photoEditingJob.isTypeBasicHDR;
    });

    // There should be exactly one basic hdr job (the first one created), otherwise return null.
    if (existingBasicHDRJobs.length !== 1) {
      return null;
    }

    const singleExistingBasicHDRJob = existingBasicHDRJobs[0];

    return singleExistingBasicHDRJob.isStatusInCreation ? singleExistingBasicHDRJob : null;
  }
}

export default CreateJobStore;
